import { createRouter } from '@tanstack/react-router'

import NotFoundPage from '@/components/not-found-page'
import { parseSearchAsStrings, stringifySearchFromStrings } from '@/lib/navigation/search'
import { routeTree } from '@/routeTree.gen'

export const router = createRouter({
  routeTree,
  // Next's Pages Router prefetched in-viewport links in production builds.
  defaultPreload: 'viewport',
  // Scroll to top on push, restore on back/forward — the browser default Next left alone.
  scrollRestoration: true,
  // Strings in, strings out: router.query keeps Next's shape (see search.ts).
  parseSearch: parseSearchAsStrings,
  stringifySearch: stringifySearchFromStrings,
  defaultNotFoundComponent: NotFoundPage,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
